import SystemSocket from './SystemSocket.js';
import Push from 'push.js';
import Api from './Api.js';

/** Mapa dostępnych dźwięków powiadomień. Klucz null oznacza brak dźwięku. */
export const SOUNDS = {
    'rooster':  require("./assets/sounds/mixkit-rooster-crowing-in-the-morning-2462.wav"),
    'bell':     require("./assets/sounds/mixkit-bell-notification-933.wav"),
    'bubble':   require("./assets/sounds/mixkit-bubble-pop-up-alert-notification-2357.wav"),
    'magic':    require("./assets/sounds/mixkit-magic-notification-ring-2344.wav"),
    'positive': require("./assets/sounds/mixkit-positive-notification-951.wav"),
    'retro':    require("./assets/sounds/mixkit-retro-game-notification-212.wav"),
    'sheep':    require("./assets/sounds/mixkit-sheep-sounds-1741.wav"),
    // 'custom1':  require("./assets/sounds/sound1.wav"),
    // 'custom2':  require("./assets/sounds/sound2.wav"),
    // 'custom3':  require("./assets/sounds/sound3.wav"),
};

/** Etykiety wyświetlane użytkownikowi dla każdego klucza dźwięku */
export const SOUND_LABELS = {
    'rooster':  'Kogut',
    'bell':     'Dzwonek',
    'bubble':   'Bąbelki',
    'magic':    'Magia',
    'positive': 'Pozytywny',
    'retro':    'Retro',
    'sheep':    'Owca',
};

const STORAGE_KEY = 'frontend_notification_sound';
const DEFAULT_SOUND_KEY = 'bell';

let packIcon = require('./assets/images/box-color.png');

let isEnabled = false;
let $router = null;
let currentSoundKey = DEFAULT_SOUND_KEY;

SystemSocket.socket.on('service_exiting', (msg) => {
    if (!isEnabled) return;
    Push.create("System chwilowo niedostępny", {
        body: "Jedna z usług systemu jest właśnie przeładowywana. Przez ok 10sek mogą być problemy z korzystaniem z aplikacji",
        // icon: '/icon.png',
        timeout: 6000
    });
});

SystemSocket.socket.on('object', (msg) => {
    if (!isEnabled) return;

    if (msg.object == 'notification' && msg.verb == 'create' && msg.data) {
        if (msg.data.code == 'task_ready_to_ship') notfifTaskReadyToShip(msg.data);
        else if (msg.data.code == 'new_task_to_confirm') notfifTaskNeedConfirm(msg.data);
        else if (msg.data.code == 'wfirma_order_edited') notfifWfirmaOrderEdited(msg.data);
        else if (msg.data.code == 'wfirma_order_removed') notfifWfirmaOrderRemoved(msg.data);
    } else if (msg.object == 'ticket_message' && msg.verb == 'save' && msg.data && msg.data.type == 'incoming') {
        playNotificationSound();
        Push.create("Nowa wiadomość od " + msg.data.fromEmail, {
            body: "Kliknij tutaj aby przejść do sprawy i odpowiedzieć na wiadomość",
            // icon: '/icon.png',
            timeout: 4000,
            onClick: function () {
                window.focus();
                if ($router && msg.data) $router.push({ name: 'ticket-details', params: { id: msg.data.ticketId } })
                this.close();
            }
        }); 
    }
});

function notfifWfirmaOrderRemoved(notif) {
    Push.create("Wykryto usunięcie dokumetnu!", {
        body: "Dokument po stronie wfirma został usuniety. Kliknij tutaj aby przejść do zamówienia i sprawdzić zmiany",
        // icon: '/icon.png',
        timeout: 4000,
        onClick: function () {
            window.focus();
            if ($router && notif.data) $router.push({ name: 'order-details', params: { id: notif.data.orderId } })
            this.close();
        }
    });
}

function notfifWfirmaOrderEdited(notif) {
    Push.create("Wykryto modyfikację zamówienia!", {
        body: "Dokument po stronie wfirma został zmodyfikowany. Kliknij tutaj aby przejść do zamówienia",
        // icon: '/icon.png',
        timeout: 4000,
        onClick: function () {
            window.focus();
            if ($router && notif.data) $router.push({ name: 'order-details', params: { id: notif.data.orderId } })
            this.close();
        }
    });
}

function notfifTaskReadyToShip(notif) {
    Push.create("Ukończono pakowanie zlecenia!", {
        body: "Kliklnij tutaj aby przejść do zamówienia",
        // icon: '/icon.png',
        timeout: 4000,
        onClick: function () {
            window.focus();
            if ($router && notif.data) $router.push({ name: 'order-details', params: { id: notif.data.orderId } })
            this.close();
        }
    });
}

function notfifTaskNeedConfirm(notif) {
    Push.create("Nowe zadanie wymaga potwierdzenia!", {
        body: "Kliklnij tutaj aby przejść do zamówienia",
        icon: packIcon,
        timeout: 4000,
        onClick: function () {
            window.focus();
            if ($router && notif.data) $router.push({ name: 'order-details', params: { id: notif.data.orderId } })
            this.close();
        }
    });
}

/**
 * Odtwarza aktualnie wybrany dźwięk powiadomienia.
 * Nie robi nic, gdy użytkownik wybrał brak dźwięku.
 */
function playNotificationSound() {
    if (!currentSoundKey || !SOUNDS[currentSoundKey]) return;
    const audio = new Audio(SOUNDS[currentSoundKey]);
    audio.play();
}

export default {
    /**
     * Uruchamia systemowe powiadomienia (w postaci dymkow)
     * @param {object} router Vue'owski router, zeby moc kierowac uzytkownikow po klikniecu w dymek
     */
    enable: async function(router) {
        isEnabled = true;
        Push.Permission.request();
        if (router) $router = router;

        try {
            const saved = await Api.system.storage.get(STORAGE_KEY);
            if (saved !== undefined && saved !== null) currentSoundKey = saved.value;
        } catch (e) {
            // Nie blokuj działania przy błędzie wczytywania preferencji
        }
    },
    disable: function() {
        isEnabled = false;
    },
    /**
     * Ustawia aktywny dźwięk powiadomień.
     * @param {string|null} key Klucz z mapy SOUNDS lub null/'' dla braku dźwięku
     */
    setSound: function(key) {
        currentSoundKey = key || null;
    }
};